<template>
    <div id="idPostList">
        <div class="row">
            <div class="panel panel-default"  v-if="this.loading">
                <div class="panel-body">
                    <h4 class="text-center text-muted mt-2 mb-2">
                        Loading posts...
                    </h4>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="panel panel-default"  v-if="(!this.loading) && (!posts.length)">
                <div class="panel-body">
                    <h3 class="text-center mt-2 mb-2">
                        There are no posts to display
                        <button v-if="canManagePosts" class="btn btn-success" @click="addNewPost()">Post something now</button>
                    </h3>
                </div>
            </div>
        </div>
        <div class="row" v-for="post in posts">
        <div class="panel panel-default">
            <div class="panel-body">
                <div class="media">
                    <div class="media-left">
                        <img class="media-thumb media-object" v-if="post.image.id" :src="post.image.thumb_180_url" :alt="post.title">
                        <img class="media-thumb media-object" v-if=" ! post.image.id" src="/images/1pixel.png" width="180" height="180" alt="Image"><br />

                    </div>
                    <div class="media-body">
                        <div class="media-heading">
                            <span class="post-title" v-if="post.title">{{ post.title }}
                                <span class="post-buttons">
                                    <a class="" v-if="canManagePosts" @click="editPost(post.id)"><i class="fas fa-pencil-alt fa-sm"></i></a>
                                    <a class="text-danger" v-if="canManagePosts" @click="remove(post.id)"><i class="fas fa-trash-alt fa-sm"></i></a>
                                </span>
                            </span>

                            <p class="post-attribution" v-html="attributionString(post)">
                                
                            </p>
                        </div>
                        <div class="post-tags" v-if="post.tags.length > 0">
                            <span v-for="tag_name in post.tags"><span class="label label-default">{{ tag_name }}</span>&nbsp;</span>
                        </div>
                        <div class="media-text post-body" v-html="post.html_content">
                        </div>
                        <div class="media-attachments">
                            <p><b>Attachments</b></p>
                            <div v-for="attachment in post.attachments">
                            <a :href="getFileUrl(post.id, attachment)">
                                <img class="icon-small" v-bind:src="attachment.icon_url" />&nbsp;{{ attachment.file_name }}
                            </a>
                            <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </div>
</template>
<style scoped>
img.icon-small  {
    width: 20px;
    height: 20px;
}
.media-thumb {
    width: 180px;
}

.mb-2 {
    margin-bottom: 20px;
}

.mt-2 {
    margin-top: 20px;
}

.post-title {
    font-size: 20px;
    line-height: 20px;
}
.post-buttons {
    line-height: 20px;
}
.post-attribution {
    font-style: italic;
    color: blue;
    margin-bottom: 8px;
}
.post-body {
    margin-top: 16px;
    font-size: 16px;
}
</style>
<script>
    import axios from 'axios';

    export default {
        props: {
            clubId: Number,
            userId: {
                default: null,
                type: Number
            },
            canManagePosts: Boolean,
            filterOnlyPublished: Boolean,
            filterOnlyPublishedOnNewsfeed: Boolean,
            filterOnlyPublishedOnWebsite: Boolean,
            filterCategoryName: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                posts: [],
                loading: false,
            };
        },
        computed: {
            recordFilters : function() {
                var filters = [];
                // 'training_date:2018-01-01~~2018-03-01&format=chartjs'
                // We always have a date range filter
                if (this.filterOnlyPublished == true) {
                    filters.push('is_published:1');
                }
                if (this.filterOnlyPublishedOnNewsfeed == true) {
                    filters.push('published_on_newsfeed:1');
                }
                if (this.filterOnlyPublishedOnWebsite == true) {
                    filters.push('published_on_website:1');
                }
                if (this.filterCategoryName.length > 0) {
                    filters.push('category_name:' + this.filterCategoryName);
                }
                return 'filters=' + filters.join();
            }
        },
        mounted() {
            this.loadPosts();
        },

        methods: {
            loadPosts() {
                let postListLoading = this.$loading({ target: '#idPostList', text: 'Loading post details...' });

                axios.get('/api/v1/newsfeed/posts/all?'+ this.recordFilters)
                    .then(response => {
                        postListLoading.close();
                        this.posts = response.data;
                        this.loading = false;
                    })
                    .catch(error => {
                        this.$message({message: error.message, type: 'error'});
                    });
            },
            remove(postId) {
                axios.delete(`/api/v1/newsfeed/posts/${postId}`)
                    .then(response => {
                        this.$message({message: "Post deleted", type: 'success'});
                        this.loadPosts();
                    })
                    .catche(error => {
                        this.$message({message: error.message, type: 'error'});
                    });
            },
            attributionString(post) {
                var postDate = moment(post.created_at).tz('Europe/London').format(window.SwimManagerConfig.momentDateFormatString);
                var author = post.created_by.full_name;

                var attribution = "Posted by " + author;
                if (post.post_category.category.length > 0) {
                    attribution = attribution + ' in <b>' + post.post_category.category + '</b>';
                }
                attribution = attribution + " on " + postDate;
                if (post.published_on_website == 1) {
                    attribution = attribution + "&nbsp;<i class='fas fa-globe text-info'></i>";
                }
                if (post.published_on_twitter) {
                    attribution = attribution + "&nbsp;<i class='fab fa-twitter text-primary'></i>";
                }
                if (post.published_on_facebook) {
                    attribution = attribution + "&nbsp;<i class='fab fa-facebook text-primary'></i>";
                }
                return attribution;
            },
            editPost(postId) {
                console.log('Editing post ' + postId);
                this.$emit('edit_post', postId);
            },
            addNewPost() {
                this.$emit('add_new_post');
            },
            getFileUrl(postId, file)
            {
                return "/club/newsfeed/post/" + postId + "/files/" + file.id;
            },
        },

        filters: {
            tags: function (value) {
                if (value) {
                    return value.join(', ');
                }

                return 'No tags';
            }
        }
    }
</script>


